export const PrimaryTerms = {
  HOSPITAL: 'Hospital',
  PROTOCOL: 'Protocol',
  CONCENTRATION: 'Concentration',
  DOSE: 'Dose',
  MEDICATION: 'Medication',
  EQUIPMENT: 'Equipment'
};
